export default "/imgs/investigation-08.png"